import { useMemo } from 'preact/hooks';
export const useSwatchMap = () => {
    const swatchMap = useMemo(() => {
        var _a;
        if (typeof window === 'undefined' || !((_a = window.mrPLPConfig) === null || _a === void 0 ? void 0 : _a.swatchIconMap)) {
            console.warn('Swatch map not found in window.mrPLPConfig');
            return [];
        }
        return window.mrPLPConfig.swatchIconMap;
    }, []);
    const getSwatchByHandle = (handle) => {
        return swatchMap.find((swatch) => swatch.colourHandle.toLowerCase() === handle.toLowerCase());
    };
    const getSwatchByDisplayName = (name) => {
        return swatchMap.find((swatch) => swatch.displayName.toLowerCase() === name.toLowerCase());
    };
    const getSwatchByColor = (colorCode) => {
        return swatchMap.find((swatch) => swatch.colourCode.toLowerCase() === colorCode.toLowerCase());
    };
    return {
        swatchMap,
        getSwatchByHandle,
        getSwatchByDisplayName,
        getSwatchByColor,
    };
};
